import { useStore } from "./useStore";

const useUpdateOnboardingStore = () => {
  const [state, dispatch] = useStore();

  const updateStore = (formData) => {
    const formFields = Object.entries(formData);

    formFields.forEach((field) => {
      dispatch("ADD_FIELD", transformFields(field));
    });
  };

  const updateLocalStorage = (formData) => {
    try {
      const formFields = Object.entries(formData);
      const localStorageFields = JSON.parse(localStorage.getItem("onBoarding")) ?? [];

      const sensitiveFields = ["email", "password", "password_confirmation"];

      // Create a new array from filtered fields
      const updatedFields = localStorageFields.filter(
        (field) => !sensitiveFields.includes(field[0]),
      );

      formFields.forEach((field) => {
        const getIndex = updatedFields.findIndex((item) => item[0] === field[0]);
        if (sensitiveFields.includes(field[0])) {
          return;
        }

        if (getIndex !== -1) {
          updatedFields[getIndex] = field;
        } else {
          updatedFields.push(field);
        }
      });

      // Atomic update
      localStorage.setItem("onBoarding", JSON.stringify(updatedFields));
    } catch (error) {
      console.error("Error updating local storage:", error);
    }
  };

  const clearLocalStorage = () => {
    try {
      localStorage.removeItem("onBoarding");
    } catch (error) {
      console.error("Error clearing local storage:", error);
    }
  };

  return {
    updateStore: (data) => {
      updateStore(data);
    },
    updateLocalStorage: (data) => {
      updateLocalStorage(data);
    },
    clearLocalStorage: () => {
      clearLocalStorage();
    },
    formData: state,
  };
};

export default useUpdateOnboardingStore;

const transformFields = (fieldData) => ({
  name: fieldData[0],
  value: fieldData[1],
});
